import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Setting from '../assets/settings.json';
import { CookieService } from 'ngx-cookie-service';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  Scroll,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from './pipe/local-storage.service';

@Component({
  selector: '.app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private titleService: Title
  ) {
    var cultureCookieValue = this.cookieService.get('Culture');
    if (cultureCookieValue == '') {
      this.defaultCulture = this.data.culture[0];
    } else {
      this.defaultCulture = this.data.culture.filter(
        (current) => current.languageCultureName === cultureCookieValue
      )[0];
    }
    translate.setDefaultLang(this.defaultCulture.shorCode);
    translate.use(this.defaultCulture.shorCode);
  }

  public defaultCulture: any;

  public myScriptElement!: HTMLScriptElement;

  public data: any = Setting;

  public thisRoute: string = '';

  ngOnInit() {
    var htmlTag = document.getElementsByTagName('html')[0];
    if (this.defaultCulture.IsRightToLeft) {
      htmlTag.setAttribute('dir', 'rtl');
    } else {
      htmlTag.setAttribute('dir', 'ltr');
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.thisRoute = event.url.replace('/', '');
      }
      if (event instanceof Scroll) {
        this.translate
          .get(this.thisRoute)
          .subscribe((translatedTitle: string) => {
            this.titleService.setTitle(translatedTitle);
          });
      }
    });

    this.localStorageService.initializeDefaultKeys();
  }
  
  getRouteAnimationData() {
    console.log('Change Page');
  }
}
